function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M56.2 124.8c54.8-24.3 117.2-24.6 172.2-.6 4 1.7 7.9 3.6 11.7 5.6l14.1-24.8c-4.7-2.4-9.5-4.7-14.4-6.9-62.3-27.2-133.1-26.9-195.3.7-5.2 2.3-10.3 4.8-15.3 7.5l14 24.8c4.3-2.2 8.6-4.3 13-6.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.1 145l14 24.8a151.61 151.61 0 01153.2-1.3l14.1-24.8C176.1 111.5 106.9 112 51.1 145z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M208.2 180c-41.7-23.4-92.8-22.8-134 1.5l.4 1 13.8 23c32.7-17.9 72.1-18.4 105.3-1.5l14.5-24z"
})));